import WideModeToggle, {
  getStoredToggledWideState as getStoredToggle,
} from './WideModeToggle';

export const getStoredToggledWideState = getStoredToggle;
export default WideModeToggle;
